import { useRouter } from 'next/router';

export default function useRouterPathname() {
    const router = useRouter();
    const pathname = router.asPath?.replace(/\/$/, '');

    if (pathname === '') {
        return '/';
    }

    if (pathname.startsWith('/puntuaciones-la-liga-fantasy-jornada')) {
        return '/puntuaciones-la-liga-fantasy-jornada';
    }

    if (pathname.startsWith('/clasificacion')) {
        return '/clasificacion';
    }

    return pathname;
}
